import React, { useState, useEffect } from 'react';
import { ArrowTrendingUpIcon, CurrencyDollarIcon, BriefcaseIcon, CalculatorIcon, CreditCardIcon } from '@heroicons/react/24/outline';
import { useRoutePath } from '../../../utils/getRoutePath';
import { Link } from 'react-router-dom';

const HistoryTab = ({ register, errors, watch, setValue, inputClassName, history, customer }) => {
  const [activeHistoryTab, setActiveHistoryTab] = useState('jobs');
  const [estimates, setEstimates] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [parentInvoices, setParentInvoices] = useState([]);
  const [totalHistory, setTotalHistory] = useState({
    last12Months: 0,
    lifetimeRevenue: 0,
    totalJobs: 0,
    aov: 0,
    currentBalance: 0,
  });
  const getRoutePath = useRoutePath();

  useEffect(() => {
 
    const jobs = customer?.jobs || [];
  
    const lifetimeRevenue = jobs.reduce(
      (sum, job) => sum + Number(job?.job_total || 0),
      0
    );
  
    const totalJobs = jobs.length;
  
    const aov = totalJobs > 0
      ? lifetimeRevenue / totalJobs
      : 0;
  
    // Last 12 months revenue
    const twelveMonthsAgo = new Date();
    twelveMonthsAgo.setMonth(twelveMonthsAgo.getMonth() - 12);
  
    const last12Months = jobs.reduce((sum, job) => {
      const createdAt = new Date(job?.created_at);
  
      if (createdAt >= twelveMonthsAgo) {
        return sum + Number(job?.job_total || 0);
      }
  
      return sum;
    }, 0);
  
    // Example current balance
    const currentBalance = jobs.reduce((sum, job) => {
      return job?.is_invoiced ? sum + Number(job?.job_total || 0) : sum;
    }, 0);
  
    setTotalHistory(prev => ({
      ...prev,
      last12Months,
      lifetimeRevenue,
      totalJobs,
      aov,
      currentBalance,
    }));
  
  }, [customer]);

  useEffect(() => {
    setEstimates(customer?.estimations || []);
    setJobs(customer?.jobs || []);
    setInvoices(
      customer?.jobs?.flatMap((job) => job?.invoice ? [job?.invoice] : []) || []
    );
    setParentInvoices(customer?.parent_account?.jobs?.flatMap((job) => job?.invoice ? [job?.invoice] : []) || []);
  }, [customer])
  
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  };
 
  const renderHistoryTable = (data,type) => {
    return (
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Number
              </th>
              
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Date
              </th>

              {(type === 'jobs' || type === 'estimates') && 
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Service Tech(s)
              </th>}

              {(type === 'jobs' || type === 'estimates') && 
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
               Service Locations
              </th>}

              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Amount
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            
            {data.length > 0 ? data.map((item) => (
              <tr key={item.id} className="hover:bg-gray-50">
               <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  <Link
                    target="_blank"
                    to={
                      type === 'jobs'
                        ? getRoutePath(`/jobs/view/${item?.id}`)
                        : type === 'estimates'
                        ? getRoutePath(`/estimations/view/${item?.id}`)
                        : type === 'invoices'
                        ? getRoutePath(`/invoices/view/${item?.id}`)
                        : type === 'pre-invoices'
                        ? getRoutePath(`/invoices/view/${item?.id}`)
                        : '#'
                    }
                    className="text-[#009efb] hover:underline"
                  >
                    {type === 'jobs'
                      ? item?.job_number
                      : type === 'estimates'
                      ? item?.estimation_number
                      : type === 'invoices'
                      ? item?.invoice_number
                      : type === 'pre-invoices'
                      ? item?.invoice_number
                      : 'N/A'}
                  </Link>
                </td>
                 
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  { (type === 'jobs' ? item?.formated_created_at : type === 'estimates' ? item?.formated_created_at : type === 'invoices' ? item?.formated_created_at : type === 'pre-invoices' ? item?.formated_created_at : 'N/A')}
                </td>

                {(type === 'jobs' || type === 'estimates') && 
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <ul className='list-disc list-inside'>
                    {item?.assign_techs?.map((tech) => <li key={tech?.id}>{tech?.first_name + ' ' + tech?.last_name}</li>)}
                   </ul>
                    
                  </td>}

                  {(type === 'jobs' || type === 'estimates') && 
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                   <ul className='list-disc list-inside'>
                    {item?.service_locations?.map((location) => <li key={location?.id}>{location?.street_address + ' ' + location?.city + ' ' + location?.state + ' ' + location?.zipcode}</li>)}
                   </ul>
                  </td>}

                <td className="px-6 py-4 whitespace-nowrap">
                 <span
                    className="inline-flex px-2 py-1 text-xs font-semibold rounded-full"
                    style={{
                      backgroundColor:
                        type === 'jobs'
                          ? item?.job_status?.color
                          : type === 'estimates'
                          ? item?.estimation_status?.color
                          : type === 'invoices'
                          ? item?.job?.job_status?.color
                          : type === 'pre-invoices'
                          ? item?.job?.job_status?.color
                          : '#f3f4f6',

                      color: '#fff',
                    }}
                  >
                  {type === 'jobs' ? item?.job_status?.name : type === 'estimates' ? item?.estimation_status?.name : type === 'invoices' ? item?.job?.job_status?.name : type === 'pre-invoices' ? item?.job?.job_status?.name : 'N/A'}
                 </span>
                </td>

                
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {formatCurrency(type === 'jobs' ? item?.job_total : type === 'estimates' ? item?.job_total : type === 'invoices' ? item?.job?.job_total : type === 'pre-invoices' ? item?.job?.job_total : 'N/A')}
                </td>
              </tr>
            )) : <tr>
              <td colSpan={4} className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                No data found
              </td>
            </tr>}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="space-y-8">
      {/* Revenue Widgets */}
      <div className="bg-gray-50 p-6 rounded-lg">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Revenue Overview</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          <div className="bg-white p-4 rounded-lg border border-gray-200">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <ArrowTrendingUpIcon className="h-8 w-8 text-green-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-500">Last 12 Months</p>
                <p className="text-lg font-semibold text-gray-900">{formatCurrency(totalHistory.last12Months)}</p>
              </div>
            </div>
          </div>

          <div className="bg-white p-4 rounded-lg border border-gray-200">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <CurrencyDollarIcon className="h-8 w-8 text-blue-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-500">Lifetime Revenue</p>
                <p className="text-lg font-semibold text-gray-900">{formatCurrency(totalHistory.lifetimeRevenue)}</p>
              </div>
            </div>
          </div>

          <div className="bg-white p-4 rounded-lg border border-gray-200">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <BriefcaseIcon className="h-8 w-8 text-purple-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-500">Total Jobs</p>
                <p className="text-lg font-semibold text-gray-900">{totalHistory.totalJobs}</p>
              </div>
            </div>
          </div>

          <div className="bg-white p-4 rounded-lg border border-gray-200">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <CalculatorIcon className="h-8 w-8 text-orange-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-500">AOV</p>
                <p className="text-lg font-semibold text-gray-900">{formatCurrency(totalHistory.aov)}</p>
              </div>
            </div>
          </div>

          <div className="bg-white p-4 rounded-lg border border-gray-200">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <CreditCardIcon className="h-8 w-8 text-red-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-500">Current Balance</p>
                <p className="text-lg font-semibold text-gray-900">{formatCurrency(totalHistory.currentBalance)}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Customer History */}
      <div className="bg-gray-50 p-6 rounded-lg">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Customer History</h3>
        
        {/* History Tabs */}
        <div className="border-b border-gray-200 mb-6">
          <nav className="-mb-px flex space-x-8 overflow-x-auto">
            <button
             type="button"
              onClick={() => setActiveHistoryTab('jobs')}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                activeHistoryTab === 'jobs'
                  ? 'border-[#009efb] text-[#009efb]'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Jobs
            </button>
            <button
             type="button"
              onClick={() => setActiveHistoryTab('estimates')}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                activeHistoryTab === 'estimates'
                  ? 'border-[#009efb] text-[#009efb]'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Estimates
            </button>
            <button
             type="button"
              onClick={() => setActiveHistoryTab('invoices')}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                activeHistoryTab === 'invoices'
                  ? 'border-[#009efb] text-[#009efb]'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Invoices
            </button>
            <button
             type="button"
              onClick={() => setActiveHistoryTab('parent-invoices')}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                activeHistoryTab === 'parent-invoices'
                  ? 'border-[#009efb] text-[#009efb]'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Parent Account Invoices
            </button>
          </nav>
        </div>

        {/* Tab Content */}
        <div>
          {activeHistoryTab === 'jobs' && renderHistoryTable(jobs,'jobs')}
          {activeHistoryTab === 'estimates' && renderHistoryTable(estimates,'estimates')}
          {activeHistoryTab === 'invoices' && renderHistoryTable(invoices,'invoices')}
          {activeHistoryTab === 'parent-invoices' && renderHistoryTable(parentInvoices,'pre-invoices')}
        </div>
      </div>
    </div>
  );
};

export default HistoryTab; 